import { render } from "./LegacyTrigger.vue?vue&type=template&id=15ee8a86"
import script from "./LegacyTrigger.vue?vue&type=script&lang=js"
export * from "./LegacyTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script